<template>
  <div>
    <el-form
      :model="addContractorsForm"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Наименование">
            <el-select
              style="width: 100%"
              @change="getEgr"
              :disabled="typeWriteTitle"
              class="searchPole"
              clearable
              v-model="addContractorsForm.egr"
              filterable
              remote
              value-key="id"
              reserve-keyword
              placeholder="Полное наименование"
              :remote-method="getEgrNames"
            >
              <el-option
                v-for="item in egrNamesList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-checkbox @change="changeTypeWriteTitle" v-model="typeWriteTitle"
              >Ручной ввод наименования</el-checkbox
            >
            <el-input
              :disabled="!typeWriteTitle"
              v-model="addContractorsForm.nameManual"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Местонахождение (юридический адрес)">
            <el-input
              :disabled="!typeWriteTitle"
              v-model="addContractorsForm.addressManual"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Телефон, факс">
            <el-input
              :disabled="!typeWriteTitle"
              v-model="addContractorsForm.phoneNumberManual"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Номер договора">
            <el-input v-model="addContractorsForm.contractNumber"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Дата подписания договора">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="addContractorsForm.contractDateFrom"
              type="date"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="Дата окончания договора">
            <el-date-picker
              style="width: 100%"
              value-format="yyyy-MM-dd"
              format="dd.MM.yyyy"
              v-model="addContractorsForm.contractDateTo"
              type="date"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="9">
          <el-button type="primary" 
          :disabled="addContractorsForm.allWastes"
          @click="openWasteDialog">
            Добавить отход</el-button> 
        </el-col>
        <el-col :span="9">
          <el-checkbox 
          v-model="addContractorsForm.allWastes">
                Разрешить все отходы
          </el-checkbox>
        </el-col>
      </el-row>

      <el-row 
  :gutter="10" 
  v-if="!addContractorsForm.allWastes && addContractorsForm.wasteIds.length > 0"
>
  <el-col :span="24">
    <el-table
      :data="selectedWastes"
      border
      size="small"
      style="width: 100%; margin-top: 10px;"
    >
      <el-table-column
        prop="name"
        label="Наименование отхода"
        min-width="200"
      />
      <el-table-column
        prop="code"
        label="Код отхода"
        width="120"
        align="center"
      />
      <el-table-column
        prop="dangerLevel"
        label="Степень опасности"
        width="150"
        align="center"
      />
      <el-table-column
        label=""
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="removeWaste(scope.row.id)"
          >
            Удалить
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-col>
</el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="ФИО ответственного лица, телефон">
            <el-input
              v-model="addContractorsForm.responsiblePersonNamePhone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button @click="save" type="primary">Добавить</el-button>
      </el-row>
    </el-form>


<el-dialog
  title="Выбор отходов"
  :visible.sync="wasteDialogVisible"
  width="600px"
  append-to-body
  destroy-on-close
>
  <el-select
    v-model="tempWasteId"
    filterable
    placeholder="Начните вводить название отхода"
    style="width: 100%"
    value-key="ss01DictionaryId"
  >
    <el-option
      v-for="item in wasteNames"
      :key="item.ss01WasteDictionaryDTO.ss01DictionaryId"
      :label="
        item.ss01WasteDictionaryDTO.wasteName +
        ' / ' +
        (item.dangerDegreeClassifierDTO == null
          ? item.ss01WasteDictionaryDTO.dangerDegreeClassifierDTO.name
          : item.dangerDegreeClassifierDTO.name)
      "
      :value="item.ss01WasteDictionaryDTO.ss01DictionaryId"
    />
  </el-select>

  <span slot="footer">
    <el-button @click="wasteDialogVisible = false">Отмена</el-button>
    <el-button type="primary" @click="confirmWasteDialog">OK</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";

export default {
  name: "contractorsAdd",
  mixins: [notification],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      typeWriteTitle: false,
      wasteDialogVisible: false,
      tempWasteId: null,  
      addContractorsForm: {
        nameManual: null,
        addressManual: null,
        phoneNumberManual: null,
        contractNumber: null,
        contractDateFrom: null,
        contractDateTo: null,
        responsiblePersonNamePhone: null,
        egr: {
          address: null,
          contacts: null,
          id: null,
          name: null,
        },
        allWastes: true,
        wasteIds: [],
      },
    };
  },

  computed: {
    ...mapGetters({
      egrNamesList: "GETEGRNAMESLIST",
      egrList: "GETEGRLIST",
      wasteNames: "GETLISTWASTEPRODUCTION",
    }),
    selectedWastes() {
    return this.addContractorsForm.wasteIds
      .map(wasteId => {
        const item = this.wasteNames.find(
          w => w.ss01WasteDictionaryDTO.ss01DictionaryId === wasteId
        );
        if (!item) return null;

        return {
          id: item.ss01WasteDictionaryDTO.ss01DictionaryId,
          name: item.ss01WasteDictionaryDTO.wasteName,
          code: item.ss01WasteDictionaryDTO.wasteCode,
          dangerLevel: item.dangerDegreeClassifierDTO == null
            ? item.ss01WasteDictionaryDTO.dangerDegreeClassifierDTO?.name
            : item.dangerDegreeClassifierDTO.name,
        };
      })
      .filter(w => w !== null);
  },
  },

  methods: {
    async getEgr() {
      await this.$store.dispatch(
        "getEgrObject",
        this.addContractorsForm.egr.id
      );
      this.addContractorsForm.phoneNumberManual =
        this.egrList.content[0].phoneNumber;
      this.addContractorsForm.addressManual = this.egrList.content[0].address;
    },

    changeTypeWriteTitle() {
      if (this.typeWriteTitle) {
        this.addContractorsForm.egrId = null;
      } else {
        this.addContractorsForm.nameManual;
      }
    },

    save() {
      if (!this.typeWriteTitle) {
        this.addContractorsForm.egrId = this.addContractorsForm.egr.id;
        this.addContractorsForm.nameManual = this.addContractorsForm.egr.name;
      }

      const payload = {
      ...this.addContractorsForm,
      wasteIds: this.addContractorsForm.allWastes 
        ? [] 
        : this.addContractorsForm.wasteIds,
    };

      this.$store
        .dispatch("createContractor", payload)
        .then((response) => {
          console.log(response);
          this.notification("Успешно", "Контрагент добавлен", "success");
          this.$store.dispatch("setShowModal", null);
          this.$store.dispatch("getAllContractors", { page: 0, size: 20 });
        });
    },

    getEgrNames(query) {
      this.$store.dispatch("getEgrNames", {
        query: query,
        size: 100,
        page: 0,
      });
    },

    openWasteDialog() {
      this.tempWasteId = null;
      this.wasteDialogVisible = true;
    },

    confirmWasteDialog() {
      if (this.tempWasteId === null) {
        this.wasteDialogVisible = false;
        return;
      }
      
      if (!this.addContractorsForm.wasteIds.includes(this.tempWasteId)) {
        this.addContractorsForm.wasteIds.push(this.tempWasteId);
      }
      
      this.wasteDialogVisible = false;
    },
    
    removeWaste(wasteId) {
      this.addContractorsForm.wasteIds = 
        this.addContractorsForm.wasteIds.filter(id => id !== wasteId);
    },

     async getWasteNames() {
      await this.$store.dispatch(
        "getOrganizationWastesListByOrganizationIdAndDate",
        null
      );
    },
  },

  async mounted() {
    this.getEgrNames("");
    await this.getWasteNames();
  },
};
</script>

<style scoped></style>
